import type { ReactNode } from 'react'

function LoyaltyDetailHeading({ children }: { children: ReactNode }) {
  return (
    <h1 className="text-ion-color-yellow text-3xl font-semibold">{children}</h1>
  )
}

export { LoyaltyDetailHeading }
